import { useQuery } from '@tanstack/react-query';

import ReservationService from '~/services/ReservationService';

import type { SalesforceSurchargePeriod } from '~/types/surcharges';

import { reservationQueryKeys } from './reservationQueryKeys';

type RawSalesforceSurchargePeriod = Omit<SalesforceSurchargePeriod, 'id'> & {
  id: string | number;
};

export function useGetSalesforceSurcharges(offerId: string | null) {
  return useQuery({
    queryKey: reservationQueryKeys.salesforceSurcharges(offerId),
    queryFn: async () => {
      const { result: surcharges } = await ReservationService.getSalesforceSurcharges(offerId);
      return surcharges.map(
        (s: RawSalesforceSurchargePeriod): SalesforceSurchargePeriod => ({
          ...s,
          id: String(s.id),
          accumulate: Boolean(s.accumulate),
          overlapping: Boolean(s.overlapping),
        }),
      );
    },
    enabled: !!offerId,
  });
}
